import React, { useState } from 'react';
import { TextField, Button, Typography, Container, InputAdornment, IconButton, Alert } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleRegister = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/register`, { name, email, password });
      setMessage('Registration successful! Redirecting to setup 2FA...');
      setError('');
      setTimeout(() => navigate("/setup-2fa"), 2000);
    } catch (error) {
      setError('Registration failed: ' + (error.response?.data?.msg || error.message));
      setMessage('');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#342F49] px-4 relative">
      <button
        className="absolute top-6 left-6 flex items-center text-[#66C5CC] font-semibold hover:underline bg-[#231E3D] px-3 py-2 rounded-lg shadow"
        onClick={() => navigate('/')}
        style={{ zIndex: 10 }}
      >
        <span className="mr-2">←</span> Home
      </button>
      <div className="w-full max-w-md bg-[#231E3D] rounded-2xl shadow-2xl p-8 sm:p-10 border border-[#66C5CC]">
        <h2 className="text-3xl font-bold text-center text-[#66C5CC] mb-8">Create Your Account</h2>
        <form onSubmit={handleRegister} className="space-y-6">
          <div>
            <label className="block text-[#66C5CC] mb-2 font-semibold">Name</label>
            <input
              type="text"
              className="w-full px-4 py-3 rounded-lg bg-[#2E2E2E] text-white border border-[#66C5CC] focus:outline-none focus:ring-2 focus:ring-[#66C5CC]"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              autoComplete="name"
            />
          </div>
          <div>
            <label className="block text-[#66C5CC] mb-2 font-semibold">Email</label>
            <input
              type="email"
              className="w-full px-4 py-3 rounded-lg bg-[#2E2E2E] text-white border border-[#66C5CC] focus:outline-none focus:ring-2 focus:ring-[#66C5CC]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="block text-[#66C5CC] mb-2 font-semibold">Password</label>
            <input
              type="password"
              className="w-full px-4 py-3 rounded-lg bg-[#2E2E2E] text-white border border-[#66C5CC] focus:outline-none focus:ring-2 focus:ring-[#66C5CC]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Create a password"
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className="block text-[#66C5CC] mb-2 font-semibold">Confirm Password</label>
            <input
              type="password"
              className="w-full px-4 py-3 rounded-lg bg-[#2E2E2E] text-white border border-[#66C5CC] focus:outline-none focus:ring-2 focus:ring-[#66C5CC]"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your password"
              autoComplete="new-password"
            />
          </div>
          {error && <div className="text-red-400 text-center font-semibold">{error}</div>}
          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-[#66C5CC] text-[#231E3D] font-bold text-lg hover:bg-[#4da5aa] transition"
          >
            Sign Up
          </button>
        </form>
        <div className="mt-6 text-center">
          <span className="text-gray-400">Already have an account? </span>
          <button
            className="text-[#66C5CC] font-semibold hover:underline"
            onClick={() => navigate('/login')}
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}

export default Register;
